<template>
  <div class="row-wrapper" :class="{ active: active }" @click="$emit('set-active')">
    <div class="name flex flex-1">{{ name }}</div>
    <div class="flex flex-1">
      <div class="measurement left">
        <span class="label">{{ $t('footscan.initial_l') }}</span>
        <span v-if="useInch" class="value">{{ left | toInch | toFixed }}</span>
        <span v-else class="value">{{ left | toFixed }}</span>
      </div>
      <div class="measurement right">
        <span class="label">{{ $t('footscan.initial_r') }}</span>
        <span v-if="useInch" class="value">{{ right | toInch | toFixed }}</span>
        <span v-else class="value">{{ right | toFixed }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import op from 'object-path';

const INCH = 0.393700787;

export default {
  name: 'MeasurementRow',
  props: {
    measurement: {
      type: Object,
      default: () => ({}),
    },
    active: Boolean,
    useInch: Boolean,
  },
  filters: {
    toFixed(value) {
      return parseFloat(value.toFixed(2));
    },
    toInch(value) {
      return value * INCH;
    },
  },
  computed: {
    name() {
      return this.measurement.name || '';
    },
    left() {
      return op.get(this.measurement, 'left.value', 0);
    },
    right() {
      return op.get(this.measurement, 'right.value', 0);
    },
  },
};
</script>

<style lang="scss" scoped>
.row-wrapper {
  @apply flex flex-row w-full items-center;
  background: #fff;
  height: 62px;
  border-radius: 11px;
  border: 1px solid rgba(0, 0, 0, 0.11);
  padding: 10px 15px;
  &.active {
    background: #f5f5f5;
    border-color: #f5f5f5;
  }
}
.name {
  color: #262626;
  word-break: break-word;
  max-width: 40%;
}
.name,
.label {
  font-size: 14px;
}
.label {
  @apply mr-3;
}
.value {
  @apply font-semibold;
  font-size: 20px;
  min-width: 60px;
}
.measurement {
  @apply flex flex-row items-center;
  &.left .label {
    color: #540deb;
  }
  &.right {
    @apply ml-3;
    .label {
      color: #2245ff;
    }
  }
}
</style>
